import React, {useState} from "react";

import groupBy from "../../utils/groupBy";

import ButtonBase from "@mui/material/ButtonBase";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";


const minWidth = "180px";

// A controlled component to select an accommodation unit.
const AccommodationUnitSelector = (props) => {
    const {
        accommodationUnits,
        value,
        onChange,
        isLoading,
        align="left",
        sx={}
    } = props;

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);

    const menuOpen = Boolean(menuAnchorEl);

    const handleOpen = (e) => {
        setMenuAnchorEl(e.currentTarget);
    }

    const handleSelect = (unit) => {
        handleClose();
        onChange(unit);
    }

    const handleClose = () => {
        setMenuAnchorEl(null);
    }

    const groupedUnits= groupBy(accommodationUnits, x => x.accommodation.name);

    return <Stack justifyContent='space-between' alignItems='center' sx={sx}>
        {
            !isLoading ?
                value && <>
                    <ButtonBase id="accommodation-unit-button"
                                aria-controls="accommodation-unit-menu"
                                aria-expanded={menuOpen ? 'true' : undefined}
                                aria-haspopup="true"
                                onClick={handleOpen}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: align === "left" ? "flex-start" : (align === "right" ? "flex-end" : "center"),
                                    minWidth: minWidth,
                                }}>

                        <Stack direction="column">
                            <Typography sx={{lineHeight: '1.25rem'}} fontWeight={600} textAlign={align}>
                                {value.name}
                            </Typography>
                            <Typography variant='caption' sx={{lineHeight: '1rem'}} textAlign={align}>
                                {value.accommodation.name}
                            </Typography>
                        </Stack>

                        {
                            accommodationUnits.length > 1 && <ArrowDropDownIcon mr={2}/>
                        }
                    </ButtonBase>

                    <Menu
                        id="accommodation-unit-menu"
                        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                        transformOrigin={{vertical: 'top', horizontal: 'left'}}
                        anchorEl={menuAnchorEl}
                        open={menuOpen}
                        onClose={handleClose}
                        MenuListProps={{'aria-labelledby': 'accommodation-unit-button'}}>
                        {
                            Object.entries(groupedUnits).flatMap(([accName, units]) => [
                                    <Typography key={accName} variant="subtitle2" sx={{py: 1, px: 1.5}}
                                                color='text.primary'>
                                        {accName}
                                    </Typography>,
                                    ...units.map(unit => (
                                        <MenuItem key={unit.id} dense onClick={() => handleSelect(unit)}>
                                            {unit.name}
                                        </MenuItem>
                                    ))
                                ]
                            )
                        }
                    </Menu>
                </>
                :
                <Skeleton variant="text" width={200} height={48}/>
        }
    </Stack>
}

export default AccommodationUnitSelector;